<template>
  <div class="listFilter" ref="listFilter" :dir="uiDirection" :style="setStyle()">
    <h2 style="position: relative">{{ dictionary.filters.filterList }}
      <i class="ri-close-line" :dir="uiDirection" @click="$emit('cancel')" />
    </h2>


    <div class="sections">
      <section v-for="(section, sectionIndex) in sections" :key="section.title" class="filterSection">
        <h3>
          {{ section.title }}
        </h3>

        <div class="filter" v-if="sectionIndex === 0" @click="selected[section.key] = []"
          :class="{ selected: selected[section.key].length === 0 }">
          <i class="ri-circle-line" v-if="selected[section.key].length > 0" />
          <i class="ri-circle-fill" v-if="selected[section.key].length === 0" />
          {{ dictionary.topTen.market }}
        </div>

        <div v-for="(filter, filterIndex) in section.filters" class="filter" :key="filterIndex"
          :class="{ selected: selected[section.key].includes(filter.value) }"
          @click="toggleCheck(filter.value, section.key)">


          <i class="ri-checkbox-blank-line" v-if="!selected[section.key].includes(filter.value)" /><i v-else
            class="ri-checkbox-fill" />
          {{ filter.label }}
        </div>
      </section>
    </div>

    <div class="listFilterActions">
      <div class="button ok" @click="$emit('applyFilter', this.selected)">{{ dictionary.filters.applyFilter }}</div>
      <div class="button reset" @click="reset()">{{ dictionary.filters.resetFilter }}</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ListFilter",
  props: ['defaultSelect', 'filterButtonRef', 'filterKeys'],
  computed: {
    sections() {

      if (!this.filterKeys) return this.sectionsList;
      return this.sectionsList.filter(section => this.filterKeys.includes(section.key));
    }
  },
  mounted() {

    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      this.position = {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      }
    } else {

      let uiDirection = this.$refs.listFilter.dir;
      let buttonPosition = this.filterButtonRef.getBoundingClientRect();
      this.position = {
        top: buttonPosition.top + 20 + 'px',
        [uiDirection === 'ltr' ? 'left' : 'right']: (buttonPosition.x - this.$refs.listFilter.getBoundingClientRect().width) + 'px'
      }

      if (uiDirection === 'ltr') {
        this.position.left = (buttonPosition.x - this.$refs.listFilter.getBoundingClientRect().width) + 'px';
      } else {

        this.position.right = (buttonPosition.x) + 'px';
      }
      if (this.defaultSelect) {
        for (let k in this.defaultSelect) {
          this.selected[k] = JSON.parse(JSON.stringify(this.defaultSelect[k]))
        }
      }
    }
  },
  
  data() {
    return {
      position: {},
      selected: {
        index: [],
        marketCap: [],
        sector: []
      },
      sectionsList: [
        {
          title: this.dictionary.filters.index,
          key: 'index',
          filters: [{
            value: 'nasdaq100',
            label: 'NASDAQ 100'
          }, {
            value: 'sp500',
            label: 'S&P 500'
          }, {
            value: 'russell2000',
            label: 'Russell 2000'
          },]
        },
        {
          title: this.dictionary.filters.marketCap,
          key: 'marketCap',
          filters: [{ value: 'microCap', label: this.dictionary.topTen.microCap },
          { value: 'smallCap', label: this.dictionary.topTen.smallCap },
          { value: 'midCap', label: this.dictionary.topTen.midCap },
          { value: 'largeCap', label: this.dictionary.topTen.largeCap },
          { value: 'megaCap', label: this.dictionary.topTen.megaCap },]
        },
        {
          title: this.dictionary.filters.sector,
          key: 'sector',
          filters: [{ value: 'Communication Services', label: this.dictionary.topTen.sectors['Communication Services'] },
          { value: 'Consumer Cyclical', label: this.dictionary.topTen.sectors['Consumer Cyclical'] },
          { value: 'Energy', label: this.dictionary.topTen.sectors['Energy'] },
          { value: 'Financial Services', label: this.dictionary.topTen.sectors['Financial Services'] },
          { value: 'Real Estate', label: this.dictionary.topTen.sectors['Real Estate'] },
          { value: 'Technology', label: this.dictionary.topTen.sectors['Technology'] },
          { value: 'Basic Materials', label: this.dictionary.topTen.sectors['Basic Materials'] },
          { value: 'Industrials', label: this.dictionary.topTen.sectors['Industrials'] },
          { value: 'Utilities', label: this.dictionary.topTen.sectors['Utilities'] },
          { value: 'Consumer Defensive', label: this.dictionary.topTen.sectors['Consumer Defensive'] },
          { value: 'Healthcare', label: this.dictionary.topTen.sectors['Healthcare'] }]
        }
      ]
    }
  },
  methods: {
    getIndex() {

      return this.selected.index;
    },
    setStyle() {

      return this.position;
    },
    reset() {

      this.$emit('reset', {});
      this.selected = {
        index: [],
        marketCap: [],
        sector: []
      }
    },
    toggleCheck(value, key) {

      const index = this.selected[key].indexOf(value);
      if (index > -1) {

        this.selected[key].splice(index, 1);
      } else {
        this.selected[key].push(value);
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/general";

h2 {
  margin: -.5rem 0 .5rem 0;
  padding: 0;
}

.listFilter {
  position: absolute;
  right: 0;
  top: 100%;
  width: 650px;
  transform: translateY(10px);
  max-height: 350px;
  background: var(--bgColor);
  border: 2px solid var(--notficationBorderColor);
  border-radius: 8px;
  z-index: 9999;
  box-shadow: 0 5px 35px 0 rgba(0, 0, 0, 0.5);
  padding: 1rem;

  @media(max-width: 768px) {
    position: fixed;
    top: unset;
    right: 0;
    bottom: 0;
    max-height: unset;
    width: 100%;
    height: 460px;
    transform: unset;
    box-sizing: border-box;
  }
}

.filterSection {
  h3 {
    margin: 0;
  }

  width: 100%;

  .filter {
    padding: 5px 0;
    cursor: pointer;
    transition: all .2s ease-in;

    &.selected {
      color: var(--highlightColor);
    }
  }
}

.sections {
  padding: 1rem 0;
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 1rem;
  overflow-y: auto;
  max-height: 255px;
  border-top: 1px solid var(--notficationBorderColor);
  border-bottom: 1px solid var(--notficationBorderColor);


  @media(max-width: 768px) {
    flex-direction: column;
    max-height: unset;
    height: 75%;
  }
}

.listFilterActions {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-top: .5rem;

  .button {
    background: #fff;
    padding: 3px 15px;
    border-radius: 8px;
    cursor: pointer;

    &.ok {
      background: var(--green);
      color: var(--green-dark) !important;
    }

    &.reset {
      background: var(--notficationBorderColor);
    }

  }
}

.ri-close-line {
  position: absolute;
  right: 0;
  top: 2px;
  cursor: pointer;
  padding: 10px;
  margin: -10px;

  &[dir="rtl"] {
    right: unset;
    left: 0;
  }
}
</style>
